import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e521d0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer-details__name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDropdown = _resolveComponent("BaseDropdown")!
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_AccountSetting = _resolveComponent("AccountSetting")!
  const _component_BaseDateInput = _resolveComponent("BaseDateInput")!
  const _component_AccountSettingsSection = _resolveComponent("AccountSettingsSection")!

  return (_openBlock(), _createBlock(_component_AccountSettingsSection, {
    class: "customer-details",
    title: _ctx.user.type == _ctx.UserType.Customer ? 'Customer details' : 'Agent details',
    loading: _ctx.loading,
    isEditable: _ctx.user.type === _ctx.UserType.Customer,
    onSubmit: _ctx.submit,
    ref: "settingsSectionRef"
  }, {
    default: _withCtx(({open}) => [
      _createVNode(_component_AccountSetting, { icon: "account/user" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.user.type === _ctx.UserType.Customer)
              ? (_openBlock(), _createBlock(_component_BaseDropdown, {
                  key: 0,
                  class: "customer-details__select",
                  disabled: !open,
                  name: "title",
                  placeholder: "Title",
                  options: _ctx.titles,
                  hasError: _ctx.v$.title.$error,
                  errors: _ctx.v$.title.$errors,
                  valid: !_ctx.v$.title.$invalid,
                  modelValue: _ctx.v$.title.$model,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.title.$model) = $event))
                }, null, 8, ["disabled", "options", "hasError", "errors", "valid", "modelValue"]))
              : _createCommentVNode("", true),
            _createVNode(_component_BaseInput, {
              disabled: !open,
              errors: _ctx.v$.firstName.$errors,
              modelValue: _ctx.v$.firstName.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.firstName.$model) = $event)),
              name: "firstName",
              placeholder: "First name"
            }, null, 8, ["disabled", "errors", "modelValue"]),
            _createVNode(_component_BaseInput, {
              disabled: !open,
              errors: _ctx.v$.lastName.$errors,
              modelValue: _ctx.v$.lastName.$model,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.lastName.$model) = $event)),
              name: "lastName",
              placeholder: "Last name"
            }, null, 8, ["disabled", "errors", "modelValue"])
          ])
        ]),
        _: 2
      }, 1024),
      (_ctx.user.type === _ctx.UserType.Customer)
        ? (_openBlock(), _createBlock(_component_AccountSetting, {
            key: 0,
            icon: "account/calendar"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BaseDateInput, {
                errors: _ctx.v$.dateOfBirth.$errors,
                modelValue: _ctx.v$.dateOfBirth.$model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.dateOfBirth.$model) = $event)),
                name: "dateOfBirth",
                placeholder: "Date of birth",
                disabled: !open
              }, null, 8, ["errors", "modelValue", "disabled"])
            ]),
            _: 2
          }, 1024))
        : _createCommentVNode("", true),
      _createVNode(_component_AccountSetting, {
        disabled: !open,
        icon: "account/map-pin",
        errors: _ctx.v$.address.$errors,
        modelValue: _ctx.v$.address.$model,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.address.$model) = $event)),
        name: "address",
        placeholder: "Street address"
      }, null, 8, ["disabled", "errors", "modelValue"]),
      _createVNode(_component_AccountSetting, {
        disabled: !open,
        errors: _ctx.v$.city.$errors,
        modelValue: _ctx.v$.city.$model,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.city.$model) = $event)),
        name: "city",
        placeholder: "City"
      }, null, 8, ["disabled", "errors", "modelValue"]),
      _createVNode(_component_AccountSetting, {
        disabled: !open,
        errors: _ctx.v$.zip.$errors,
        modelValue: _ctx.v$.zip.$model,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.zip.$model) = $event)),
        name: "zip",
        placeholder: "Zip code"
      }, null, 8, ["disabled", "errors", "modelValue"]),
      _createVNode(_component_AccountSetting, null, {
        default: _withCtx(() => [
          _createVNode(_component_BaseDropdown, {
            class: "customer-details__select",
            name: "country",
            placeholder: "Country",
            options: _ctx.countryList,
            hasError: _ctx.v$.countryCode.$error,
            errors: _ctx.v$.countryCode.$errors,
            valid: !_ctx.v$.countryCode.$invalid,
            modelValue: _ctx.v$.countryCode.$model,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.v$.countryCode.$model) = $event)),
            disabled: !open
          }, null, 8, ["options", "hasError", "errors", "valid", "modelValue", "disabled"])
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }, 8, ["title", "loading", "isEditable", "onSubmit"]))
}